module.exports = __webpack_public_path__ + "static/media/aluminio-rollo-liso.6e8d2921.jpg";